module.exports = __webpack_public_path__ + "static/Iris-4eebb413df9be9814f38ff9bfa87f623.jpg";